'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var produce = require('immer');
var effects = require('redux-saga/effects');
var networkMiddleware = require('@piconetworks/network-middleware');
var endpoints = require('@piconetworks/endpoints');
var Duck = require('extensible-duck');
var reselect = require('reselect');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var produce__default = /*#__PURE__*/_interopDefaultLegacy(produce);
var Duck__default = /*#__PURE__*/_interopDefaultLegacy(Duck);

var types = ['CREATE_GIFT', 'CREATE_GIFT_SUCCESS', 'CREATE_GIFT_ERROR', 'REDEEM_GIFT', 'REDEEM_GIFT_SUCCESS', 'REDEEM_GIFT_ERROR', 'CONVERT_GIFT', 'CONVERT_GIFT_SUCCESS', 'CONVERT_GIFT_ERROR', 'GET_GIFT', 'GET_GIFT_SUCCESS', 'GET_GIFT_ERROR'];

var creators = function creators(duck) {
  return {
    createGift: function createGift(payload) {
      return Object.assign({
        type: duck.types.CREATE_GIFT
      }, payload);
    },
    redeemGift: function redeemGift(payload) {
      return Object.assign({
        type: duck.types.REDEEM_GIFT
      }, payload);
    },
    convertGift: function convertGift(payload) {
      return Object.assign({
        type: duck.types.CONVERT_GIFT
      }, payload);
    },
    getGift: function getGift(payload) {
      return Object.assign({
        type: duck.types.GET_GIFT
      }, payload);
    }
  };
};

var initialState = {
  creatingGift: false,
  didCreateGift: null,
  redeemingGift: false,
  redeemGiftSuccess: null,
  redeemGiftError: null,
  createGiftError: null
};

var reducer = function reducer(state, _ref, duck) {
  var type = _ref.type,
      payload = _ref.payload,
      error = _ref.error;
  return produce__default['default'](state, function (draftState) {
    switch (type) {
      case duck.types.CREATE_GIFT:
        draftState.creatingGift = true;
        draftState.didCreateGift = duck.initialState.didCreateGift;
        draftState.createGiftError = duck.initialState.createGiftError;
        break;

      case duck.types.CREATE_GIFT_SUCCESS:
        draftState.creatingGift = false;
        draftState.didCreateGift = true;
        break;

      case duck.types.CREATE_GIFT_ERROR:
        draftState.creatingGift = false;
        draftState.didCreateGift = false;
        draftState.createGiftError = error;
        break;

      case duck.types.REDEEM_GIFT:
        draftState.redeemingGift = true;
        draftState.redeemGiftSuccess = duck.initialState.redeemGiftSuccess;
        draftState.redeemGiftError = duck.initialState.redeemGiftError;
        break;

      case duck.types.REDEEM_GIFT_SUCCESS:
        draftState.redeemingGift = false;
        draftState.redeemGiftSuccess = true;
        draftState.redeemGiftError = false;
        break;

      case duck.types.REDEEM_GIFT_ERROR:
        draftState.redeemingGift = false;
        draftState.redeemGiftSuccess = false;
        draftState.redeemGiftError = true;
        draftState.redeemGiftErrorMessage = payload.error;
        break;

      case duck.types.GET_GIFT_SUCCESS:
        draftState.giftId = payload.giftId;
        break;

      case duck.types.CONVERT_GIFT_SUCCESS:
        draftState.giftConversionSuccess = true;
        break;

    }
  });
};

function* redeemGift(_ref) {
  var types = _ref.types,
      giftId = _ref.giftId,
      publisherId = _ref.publisherId,
      _ref$loaderInvalidati = _ref.loaderInvalidationEvent,
      loaderInvalidationEvent = _ref$loaderInvalidati === void 0 ? function () {
    return {
      type: 'LOADER_INVALIDATION_EVENT'
    };
  } : _ref$loaderInvalidati;

  try {
    if (!giftId) {
      throw Error('giftId must be provided');
    }

    if (!publisherId) {
      throw Error('publisherId must be provided');
    }

    var _yield$putResolve = yield effects.putResolve({
      type: networkMiddleware.REQUEST,
      config: {
        method: 'put',
        baseURL: endpoints.PICO_API_URL(),
        url: "".concat(endpoints.PURCHASE_GIFT(), "/").concat(giftId),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          publisherid: publisherId
        },
        timeout: 30000,
        data: {
          publisherId: publisherId,
          status: 'activated'
        }
      }
    }),
        data = _yield$putResolve.data;

    if (data.status_code === 404) {
      throw 'This gift has already been redeemed.';
    }

    yield effects.putResolve({
      type: networkMiddleware.STORE_TOKENS,
      access_token: data.token,
      refresh_token: data.refresh_token
    });
    yield effects.put(yield effects.call(loaderInvalidationEvent, {
      payload: {
        scope: ['user']
      }
    }));
    yield effects.put({
      type: types.REDEEM_GIFT_SUCCESS,
      payload: {}
    });
  } catch (error) {
    console.log(error);
    yield effects.put({
      type: types.REDEEM_GIFT_ERROR,
      payload: {
        error: error
      }
    });
  }
}

function* createGift(_ref) {
  var types = _ref.types,
      company_slug = _ref.company_slug,
      custom_price = _ref.custom_price,
      note = _ref.note,
      product_option_id = _ref.product_option_id,
      publisherId = _ref.publisherId,
      recipient = _ref.recipient,
      sender = _ref.sender,
      tier_id = _ref.tier_id,
      redeemUrl = _ref.redeemUrl,
      formId = _ref.formId;

  try {
    var data = {
      form_id: formId,
      product_option_id: product_option_id,
      tier_id: tier_id,
      custom_price: custom_price,
      note: note,
      recipient: recipient,
      sender: sender,
      adBlocking: false,
      origin: window.location.href,
      post_id: null,
      post_type: 'home',
      prev_page: '',
      publisherId: publisherId,
      resource_ref: null,
      taxonomies: {},
      redeem_url: redeemUrl || "".concat(process.env.MARKETING_SITE_URL, "/").concat(company_slug, "/redeem-gift")
    };
    var response = yield effects.putResolve({
      type: networkMiddleware.REQUEST,
      config: {
        method: 'post',
        baseURL: endpoints.PICO_API_URL(),
        url: endpoints.PURCHASE_GIFT(),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          publisherid: publisherId
        },
        timeout: 30000,
        data: data
      }
    });
    yield effects.put({
      type: types.CREATE_GIFT_SUCCESS,
      payload: {
        data: response.data
      }
    });
  } catch (error) {
    yield effects.put({
      type: types.CREATE_GIFT_ERROR,
      error: error.message
    });
  }
}

function* getGift(_ref) {
  var types = _ref.types,
      publisherId = _ref.publisherId;

  try {
    var _yield$putResolve = yield effects.putResolve({
      type: networkMiddleware.REQUEST,
      config: {
        method: 'get',
        baseURL: endpoints.PICO_API_URL(),
        url: "".concat(endpoints.PURCHASE_GIFT(), "?status=activated"),
        headers: Object.assign({
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }, publisherId && {
          publisherid: publisherId
        }),
        timeout: 30000
      }
    }),
        data = _yield$putResolve.data;

    if (!data.id) {
      throw 'No gift found for user';
    }

    yield effects.put({
      type: types.GET_GIFT_SUCCESS,
      payload: {
        giftId: data.id
      }
    });
  } catch (error) {
    yield effects.put({
      type: types.GET_GIFT_ERROR,
      error: error.message
    });
  }
}

function* convertGift(_ref) {
  var types = _ref.types,
      giftId = _ref.giftId,
      publisherId = _ref.publisherId,
      _ref$loaderInvalidati = _ref.loaderInvalidationEvent,
      loaderInvalidationEvent = _ref$loaderInvalidati === void 0 ? function () {
    return {
      type: 'LOADER_INVALIDATION_EVENT'
    };
  } : _ref$loaderInvalidati;

  try {
    var _yield$putResolve = yield effects.putResolve({
      type: networkMiddleware.REQUEST,
      config: {
        method: 'put',
        baseURL: endpoints.PICO_API_URL(),
        url: "".concat(endpoints.PURCHASE_GIFT(), "/").concat(giftId),
        headers: Object.assign({
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }, publisherId && {
          publisherid: publisherId
        }),
        timeout: 30000,
        data: {
          status: 'converted'
        }
      }
    }),
        data = _yield$putResolve.data;

    if (data && !data.success) {
      throw 'Error with converting gift';
    }

    yield effects.put(yield effects.call(loaderInvalidationEvent, {
      payload: {
        scope: ['user']
      }
    }));
    yield effects.put({
      type: types.CONVERT_GIFT_SUCCESS,
      payload: {}
    });
  } catch (error) {
    yield effects.put({
      type: types.CONVERT_GIFT_ERROR,
      error: error.message
    });
  }
}

var sagas = function sagas(duck) {
  return {
    redeemGift: function* redeemGift$1(payload) {
      yield redeemGift(Object.assign({}, payload, duck));
    },
    createGift: function* createGift$1(payload) {
      yield createGift(Object.assign({}, payload, duck));
    },
    getGift: function* getGift$1(payload) {
      yield getGift(Object.assign({}, payload, duck));
    },
    convertGift: function* convertGift$1(payload) {
      yield convertGift(Object.assign({}, payload, duck));
    }
  };
};

var takes = function takes(_ref) {
  var types = _ref.types,
      sagas = _ref.sagas;
  return [effects.takeEvery(types.CREATE_GIFT, sagas.createGift), effects.takeEvery(types.REDEEM_GIFT, sagas.redeemGift), effects.takeEvery(types.GET_GIFT, sagas.getGift), effects.takeEvery(types.CONVERT_GIFT, sagas.convertGift)];
};

var selectors = function selectors() {
  return {
    gift: new Duck__default['default'].Selector(function () {
      return function (state) {
        return state === null || state === void 0 ? void 0 : state.gift;
      };
    }),
    giftId: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.gift, function (_ref) {
        var giftId = _ref.giftId;
        return giftId;
      });
    }),
    giftConversionSuccess: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.gift, function (_ref2) {
        var giftConversionSuccess = _ref2.giftConversionSuccess;
        return giftConversionSuccess;
      });
    }),
    didCreateGift: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.gift, function (_ref3) {
        var didCreateGift = _ref3.didCreateGift;
        return didCreateGift;
      });
    }),
    creatingGift: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.gift, function (_ref4) {
        var creatingGift = _ref4.creatingGift;
        return creatingGift;
      });
    }),
    createGiftError: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.gift, function (_ref5) {
        var createGiftError = _ref5.createGiftError;
        return createGiftError;
      });
    })
  };
};

var storeDefault = 'gift';
var index = (function (_ref) {
  var _ref$store = _ref.store,
      store = _ref$store === void 0 ? storeDefault : _ref$store,
      createDuck = _ref.createDuck,
      _ref$initialState = _ref.initialState,
      initialState$1 = _ref$initialState === void 0 ? initialState : _ref$initialState,
      _ref$creators = _ref.creators,
      creators$1 = _ref$creators === void 0 ? creators : _ref$creators,
      _ref$types = _ref.types,
      types$1 = _ref$types === void 0 ? types : _ref$types,
      _ref$reducer = _ref.reducer,
      reducer$1 = _ref$reducer === void 0 ? reducer : _ref$reducer,
      _ref$sagas = _ref.sagas,
      sagas$1 = _ref$sagas === void 0 ? sagas : _ref$sagas,
      _ref$takes = _ref.takes,
      takes$1 = _ref$takes === void 0 ? takes : _ref$takes,
      _ref$selectors = _ref.selectors,
      selectors$1 = _ref$selectors === void 0 ? selectors : _ref$selectors;
  return createDuck({
    store: store,
    initialState: initialState$1
  }).extend({
    creators: creators$1,
    types: types$1,
    reducer: reducer$1,
    sagas: sagas$1,
    takes: takes$1,
    selectors: selectors$1
  });
});

exports.creators = creators;
exports.default = index;
exports.initialState = initialState;
exports.reducer = reducer;
exports.sagas = sagas;
exports.store = storeDefault;
exports.takes = takes;
exports.types = types;
